import type { Directive } from 'vue'
import { Capacitor } from '@capacitor/core'
import { Keyboard } from '@capacitor/keyboard'

const vHideKeyboardScroll: Directive<HTMLElement> = {
  mounted(el) {
    if (!Capacitor.isNativePlatform()) return
    el.addEventListener('touchmove', () => Keyboard.hide(), { passive: true })
  },
}

export default vHideKeyboardScroll
